import {Store} from "vuex";
import {stateKey} from "@share/web-conferences/helpers/StateKey";
import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";
import {
    addJoinedUserAction,
    removeJoinedUserAction,
    setAgoraAction, setTracksManager,
    setWebConferenceDataAction
} from "@share/web-conferences/store/actions";
import {SetAgoraParams} from "@share/web-conferences/types/SetAgoraParams";
import {WebConferenceJoinResultInterface} from "@api/models/interfaces/web-conference/WebConferenceJoinResultInterface";
import {StoreParameters} from "@share/web-conferences/types/StoreParameters";
import {WebConferenceJoinResult} from "@api/models/web-conferences/WebConferenceJoinResult";
import { TracksManagerCommonInterface } from "@share/web-conferences/types/TracksManagerCommonInterface";

export class StoreHelper {
    public readonly stateKey: string;

    constructor(
        public readonly store: Store<any>,
        schemaId: string,
        objectId: string
    ) {
        this.stateKey = stateKey(schemaId, objectId);
    }

    setAgora(agora: AgoraInterface) {
        this.store.dispatch(setAgoraAction, { key: this.stateKey, agora: agora } as SetAgoraParams);
    }

    setWebConferenceData(data: WebConferenceJoinResult) {
        this.store.dispatch(setWebConferenceDataAction, { key: this.stateKey, data: data } as StoreParameters<WebConferenceJoinResultInterface>)
    }

    removeJoinedUser(userId: number) {
        this.store.dispatch(removeJoinedUserAction, {userId: userId, key: this.stateKey});
    }

    addJoinedUser(userId: number) {
        this.store.dispatch(addJoinedUserAction, {userId: userId, key: this.stateKey});
    }

    setTracksManager(tracksManager: TracksManagerCommonInterface) {
        this.store.dispatch(setTracksManager, { key: this.stateKey, data: tracksManager } as StoreParameters<TracksManagerCommonInterface>);
    }
}
